<template>
  <div>
    <mi-btn
      flat
      no-hover
      class="button-wrapper return-back"
      icon="arrow-left"
      @click="handleAppFeatureClick()"
    >
      Back
    </mi-btn>
  </div>
</template>

<script>
  import { useRouter } from 'vue-router'

  export default {
    name: 'MiBackBtn',
    props: {
      to: {
        type: String,
        required: false,
        default: '/'
      }
    },
    setup(props) {
      const router = useRouter()

      const handleAppFeatureClick = () => {
        router.push({ name: props.to })
      }

      return {
        router,
        handleAppFeatureClick
      }
    }
  }
</script>

<style lang="scss" scoped>
  // stylelint-disable declaration-no-important
  .button-wrapper {
    display: flex;
    align-items: center;
    gap: 10px;
    cursor: pointer;

    ::v-deep(.q-focus-helper) {
      display: none !important;
    }
  }

  ::v-deep(.mi-btn.q-btn.q-btn--flat.button-wrapper:hover) {
    background-color: transparent !important;
    color: $mi-anthracite-800 !important;
  }

  .return-back {
    color: $mi-anthracite-800;
    text-transform: uppercase;
    text-decoration: none;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    background: none;
    border: 0;
    padding: 0;
  }
</style>
